import { IPromise, IHttpService } from "angular";

import { IMasterplan, IUninstallMasterplan } from "../models/models";
import { IConnectorBlueprint } from "@gtmhub/connectors/models";
import { EnvironmentService } from "@gtmhub/env";
import { ICollection } from "@gtmhub/models";

export class InstallerService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public getMasterplans(): IPromise<IMasterplan[]> {
    const url = this.env.getApiEndpoint("/masterplans");

    return this.$http.get<ICollection<IMasterplan>>(url).then((response) => response.data.items);
  }

  public getRequiredConnectors(plans: string[]): IPromise<IConnectorBlueprint[]> {
    const url = this.env.getApiEndpoint("/masterplans/connectors");

    return this.$http.post<ICollection<IConnectorBlueprint>>(url, plans).then((response) => response.data.items);
  }

  public install(plans: string[]): IPromise<boolean> {
    const url = this.env.getApiEndpoint("/masterplans/install");

    return this.$http.post<boolean>(url, plans).then((response) => response.data);
  }

  public uninstall(masterplanId: string): IPromise<boolean> {
    const url = this.env.getApiEndpoint("/masterplans/" + masterplanId + "/uninstall");
    const request: IUninstallMasterplan = {
      removeInsights: true,
      removeConnectorsAndDatasources: true,
      removeEntities: true,
      removeDashboards: true,
    };

    return this.$http.post<boolean>(url, request).then((response) => response.data);
  }
}
